<template>
    <div class="admin-variant">
        <div v-if="variant._id === null">
            <form class="styledForm">
                <div class="form">
                    <div class="ssm-main-infos">
                        <input class="styledInput" type="text" v-model="model._id" placeholder="ID du model" name="product id" required>
                    </div>
                </div>
            </form>
            <div class="flex">
                <hr>
                <p>Or</p>
                <hr>
            </div>
            <form class="styledForm">
                <div class="form">
                    <div class="ssm-main-infos">
                        <input
                            class="styledInput"
                            type="text"
                            v-model="model.name"
                            placeholder="Model Name">
                        <input
                            class="styledInput"
                            type="text"
                            v-model="model.ean"
                            placeholder="Model ean">
                        <autocomplete
                                placeholder="Brand"
                                :source="brands"
                                resultsValue="_id"
                                :resultsDisplay="(e) => e.name"
                                :initialDisplay="model.brand ? model.brand.name : ''"
                                @selected="(item) => model.brand = item.selectedObject"
                        />
                        <button type="button" @click="createAProduct(model)" class="green-btn">Create Model</button>
                    </div>
                </div>
            </form>
        </div>
        <div v-else class="variants">
            <div class="model" @click="modal = 'model'">Model</div>
            <router-link
                :to="`/admin/product/variant/${v._id}`"
                v-for="v in variants"
                :key="v._id"
                class="variant">
                <img class="adm-img" v-lazy="imgURL + '/' + v.mainPicture" alt="main picture">
            </router-link>
            <div v-if="variant._id" class="model duplicate" @click="duplicateThisVariant(variant._id)">Duplicate</div>
        </div>
        <Popup
            :opened="modal == 'model'"
            title="Model"
            @close="modal = ''">
            <template>
                <div class="form">
                    <input
                        class="styledInput m-b-30"
                        type="text"
                        v-model="variant.productId"
                        placeholder="Model Id"
                        @change="getNewModel(variant.productId);getProductVariants(variant.productId);">
                    <div v-if="model && model._id != null && model._id !== ''">
                        <input
                                class="styledInput"
                                type="text"
                                v-model="model.ean"
                                placeholder="Model Name">
                        <autocomplete
                                :source="brands"
                                resultsValue="_id"
                                :resultsDisplay="(e) => e.name"
                                :initialDisplay="model.brand ? model.brand.name : ''"
                                @selected="(item) => model.brand = item.selectedObject"
                        />
                        <button @click="updateProduct(model)" class="green-btn">Update</button>
                    </div>
                </div>
            </template>
        </Popup>
        <form class="styledForm" @submit="(e) => e.preventDefault()">
            <div class="form">
                <h2>Variant {{ variant.ean }}</h2>
                <div class="ssm-main-infos">
                    <Expand title="Product Reference" :expand="true">
                        <div>
                            <div class="split">
                                <input class="styledInput" type="text" v-model="variant.ean" placeholder="EAN" name="EAN">
                            </div>
                            <div class="split">
                                <input class="styledInput" type="text" v-model="variant.ucp" placeholder="Item Model Number" name="UCP">
                            </div>
                        </div>
                    </Expand>
                    <Expand title="Collaborators">
                        <div>
                            <div class="split">
                                <autocomplete
                                    :source="brands"
                                    resultsValue="_id"
                                    @selected="(item) => variant.collaborators.push(brands.filter(e => e._id === item.value)[0])"
                                />
                            </div>
                            <div class="tag-list">
                                <p class="tag" v-for="(i, index) in variant.collaborators" :key="i._id" @click="variant.collaborators.splice(index, 1)">{{ i.name }}</p>
                            </div>
                        </div>
                    </Expand>

                    <Expand title="Marketplaces">
                        <div class="marketplaces">
                            <div
                                class="item"
                                v-for="(market, index) in variant.marketplaces"
                                :key="market._id">
                                <button class="close" @click="variant.marketplaces.splice(index, 1); setTimeout(() => modal='', 200)">x</button>
                                <h3>
                                    <a target="_blank" :href="market.website">{{ market.name }}</a>
                                    <font-awesome-icon @click="modal='marketplace'; marketplace = market" icon="pen"></font-awesome-icon>
                                </h3>
                                <p>{{ market.qte }} ± {{ getCurrency(market.currency)[1] }} {{ market.price }} {{ getCurrency(market.currency)[0] }}</p>
                            </div>
                            <div class="item green-btn" @click="modal='marketplace'; marketplace = JSON.parse(JSON.stringify(emptyMarketplace))">
                                <h3>Ajouter une marketplace</h3>
                            </div>
                        </div>
                    </Expand>
                    <div>
                        <div class="split">
                            <textarea v-model="variant.comment" placeholder="Commentaire"></textarea>
                        </div>
                        <div class="split">
                            <textarea v-model="variant.description" placeholder="Description"></textarea>
                        </div>
                    </div>

                    <Expand title="materials" :expand="true">
                        <div>
                            <div>
                                <div class="split">
                                    <autocomplete
                                        :source="tags['materials']"
                                        resultsValue="_id"
                                        :resultsDisplay="(e) => `${e.name} ${e.equivalents.length < 1 ? '' : `(${e.equivalents.map((eq) => eq)})`}`"
                                        @selected="(item) => variant.tags.push(tags['materials'].filter(e => e._id === item.value)[0])"
                                        @nothingSelected="(item) => {findOrCreateTag(item, 'materials')}"
                                    />
                                </div>
                                <div class="split">
                                    <div class="tag-list">
                                        <p class="tag" v-for="i in variant.tags.filter(t => t.type === 'materials')" :key="i._id" @click="variant.tags = variant.tags.filter(e => e._id !== i._id)">{{ i.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <button class="green-btn" @click="hierarchyOpened['materials'] = !hierarchyOpened['materials']">Show/Hide Hierarchy</button>
                            <Hierarchy :tags="tags['materials']" v-if="hierarchyOpened['materials']"/>
                        </div>
                    </Expand>

                    <div>
                        <div class="split">
                            <div class="custom-input">
                                <input type="file" placeholder="Chose a picture" @change="e => onFileChange(e)">
                                <button @click="uploadPicture()">+</button>
                            </div>
                        </div>
                        <div class="split">
                            <div class="custom-input">
                                <input type="text" placeholder="Chose a picture from internet" v-model="url" @keydown.enter="uploadPictureFromInternet(url)">
                                <button @click="uploadPictureFromInternet(url)">+</button>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-img">
                        <h3>Desktop Images</h3>
                        <div class="img-container">
                            <div class="img-item" v-if="variant.mainPicture">
                                <button @click="variant.mainPicture = ''">
                                    <font-awesome-icon icon="minus"></font-awesome-icon>
                                </button>
                                <img class="adm-img" v-lazy="imgURL+'/'+variant.mainPicture" alt="main picture">
                            </div>
                            <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
                            <div class="img-item" v-for="(i, index) in variant.pictures" :key="i" v-if="i !== variant.mainPicture">
                                <button @click="variant.mainPicture = i">
                                    <font-awesome-icon icon="plus"></font-awesome-icon>
                                </button>
                                <button @click="variant.mobilePictures.push(i); variant.pictures.splice(index, 1)">
                                    <font-awesome-icon icon="mobile"></font-awesome-icon>
                                </button>
                                <button class="remove" @click="variant.pictures.splice(index, 1)">
                                    <font-awesome-icon icon="times"></font-awesome-icon>
                                </button>
                                <img class="adm-img" v-lazy="imgURL+'/'+i" alt="product picture">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-img">
                        <h3>Mobile Images</h3>
                        <div class="img-container">
                            <div class="img-item" v-for="(i, index) in variant.mobilePictures" :key="i">
                                <button @click="variant.pictures.push(i); variant.mobilePictures.splice(index, 1)">
                                    <font-awesome-icon icon="desktop"></font-awesome-icon>
                                </button>
                                <button class="remove" @click="variant.mobilePictures.splice(index, 1)">
                                    <font-awesome-icon icon="times"></font-awesome-icon>
                                </button>
                                <img class="adm-img" v-lazy="imgURL+'/'+i" alt="product picture">
                            </div>
                        </div>
                    </div>

                    <Expand title="Colors">
                        <div>
                            <div class="split">
                                <div class="tag-list">
                                    <p class="tag color-tag" v-for="(i, index) in variant.mainColors" :key="i._id" @click="variant.mainColors.splice(index, 1)">
                                        <span :style="{backgroundColor: i.color}" />{{ i.colorName }}
                                    </p>
                                </div>
                                <autocomplete
                                    :source="colors"
                                    resultsValue="_id"
                                    :resultsDisplay="(e) => `<span class='color-square' style='background-color: ${e.color}'></span>${e.colorName}`"
                                    @selected="(item) => variant.mainColors.push(colors.filter(e => e._id === item.value)[0])"
                                    @nothingSelected="(item) => {findOrCreateColor(item, 'main')}"
                                />
                            </div>
                            <div class="split">
                                <div class="tag-list">
                                    <p class="tag color-tag" v-for="(i, index) in variant.colors" :key="i._id" @click="variant.colors.splice(index, 1)">
                                        <span :style="{backgroundColor: i.color}" />{{ i.colorName }}
                                    </p>
                                </div>
                                <autocomplete
                                    :source="colors"
                                    resultsValue="_id"
                                    :resultsDisplay="(e) => `<span class='color-square' style='background-color: ${e.color}'></span>${e.colorName}`"
                                    @selected="(item) => variant.colors.push(colors.filter(e => e._id === item.value)[0])"
                                    @nothingSelected="(item) => {findOrCreateColor(item, 'normal')}"
                                />
                            </div>
                        </div>
                    </Expand>
                    <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
                    <Expand v-for="(type, key) in tags" :title="key" :key="key" v-if="key !== 'materials'" :expand="key === 'style'">
                        <div>
                            <div>
                                <div class="split">
                                    <autocomplete
                                        :source="type"
                                        resultsValue="_id"
                                        :resultsDisplay="(e) => `${e.name} ${e.equivalents.length < 1 ? '' : `(${e.equivalents.map((eq) => eq)})`}`"
                                        @selected="(item) => variant.tags.push(type.filter(e => e._id === item.value)[0])"
                                        @nothingSelected="(item) => {findOrCreateTag(item, key)}"
                                    />
                                </div>
                                <div class="split">
                                    <div class="tag-list">
                                        <p class="tag" v-for="i in variant.tags.filter(t => t.type === key)" :key="i._id" @click="variant.tags = variant.tags.filter(e => e._id !== i._id)">{{ i.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <button class="green-btn" @click="hierarchyOpened[key] = !hierarchyOpened[key]">Show/Hide Hierarchy</button>
                            <Hierarchy :tags="type" v-if="hierarchyOpened[key]"/>
                        </div>
                    </Expand>
                    <div>
                        <div class="split">
                            <input class="styledInput" type="text" v-model="variant.list" placeholder="Listes" name="list">
                        </div>
                        <div class="split">
                            <div class="split">
                                <div class="check">
                                    <label for="online">Is Online: </label>
                                    <input type="checkbox" name="online" id="online" v-model="variant.online">
                                    <label class="slide" for="online"><div></div></label>
                                </div>
                            </div>
                            <div class="split">
                                <div class="check">
                                    <label for="online">Is available: </label>
                                    <input type="checkbox" name="online" id="available" v-model="variant.available">
                                    <label class="slide" for="available"><div></div></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button @click="saveVariant" class="green-btn">{{ variant._id === null ? 'Enregistrer' : 'Modifier' }}</button>
                </div>
            </div>
        </form>
        <Popup :opened="modal == 'marketplace'" @close="modal = ''">
            <template>
                <div class="styledForm">
                    <div>
                        <autocomplete
                            :source="marketplaces"
                            :initialValue="marketplace._id"
                            resultsValue="_id"
                            :resultsDisplay="(e) => e.name"
                            @selected="(item) => marketplace._id = item.value"
                        />
                    </div>
                    <div>
                        <div class="split">
                            <input class="styledInput" type="text" v-model="marketplace.name" placeholder="name" name="name">
                        </div>
                        <div class="split">
                            <input class="styledInput" type="text" v-model="marketplace.asin" placeholder="UCP" name="UCP">
                        </div>
                    </div>
                    <div>
                        <input class="styledInput" type="text" v-model="marketplace.website" placeholder="website" name="website">
                    </div>
                    <div>
                        <div class="split">
                            <div>
                                <div class="split">
                                    <input class="styledInput" type="text" v-model="marketplace.price" placeholder="average price" name="price">
                                </div>
                                <div class="split">
                                    <select class="styledInput" v-model="marketplace.currency" name="currency">
                                        <option v-for="c in currencies" :key="c[0]" :value="c[0]">{{ c[1] }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="split">
                            <div class="split">
                                <input class="styledInput" type="number" v-model="marketplace.qte" placeholder="quantity" name="quantity">
                            </div>
                            <div class="split">
                                <select class="styledInput" v-model="marketplace.availability" name="availability">
                                    <optgroup label="IN">
                                        <option value="In Stock" selected>In Stock</option>
                                        <option value="Coming Soon / Pre-Order">Coming Soon / Pre-Order</option>
                                        <option value="Limited Edition">Limited Edition</option>
                                        <option value="Unique Piece">Unique Piece</option>
                                        <option value="Second Hand">Second Hand</option>
                                        <option value="Few in Stock">Few in Stock</option>
                                    </optgroup>
                                    <optgroup label="OUT">
                                        <option value="Out of Stock">Out of Stock</option>
                                        <option value="Seeking New Stock">Seeking New Stock</option>
                                        <option value="Rare">Rare</option>
                                        <option value="Unfindable">Unfindable</option>
                                        <option value="Not for sale">Not for sale</option>
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button @click="addMarketplace" class="submit-btn">{{ marketplace.new ? 'Add a marketplace' : 'Enregistrer et fermer' }}</button>
                    </div>
                </div>
            </template>
        </Popup>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Swal from "sweetalert2";
    import Autocomplete from 'vuejs-auto-complete'
    import Expand from '../../../components/Expand';
    import Hierarchy from '../../../components/Hierarchy';
    import Popup from "../../../components/Popup";

    export default {
        name: "AdminVariant",
        components: {Popup, Autocomplete, Expand, Hierarchy},
        created() {
            if (this.$route.params.id) {
                this.getVariant(this.$route.params.id).then(data => {
                    if (data.data.variant) this.variant = data.data.variant;
                    this.getProduct(this.variant.productId).then(data => {
                        this.model = data.product;
                    });
                    this.getProductVariants(this.variant.productId).then(data => {
                       this.variants = data.variants;
                    });
                    this.variant.marketplaces.map((m) => {
                        m.availability = this.oldDispos[m.availability];
                    });
                });
            }
            this.getMarketplaces();
            this.getBrands();
            this.getColors();
            for (const t of ['style', 'category', 'tag', 'devices', 'materials']) this.getTags(t);
        },
        watch: {
            $route (to){
                if (to.params.id) {
                    this.getVariant(to.params.id).then(data => {
                        if (data.data.variant) this.variant = data.data.variant;
                        this.getProduct(this.variant.productId).then(data => {
                            this.model = data.product;
                        });
                        this.getProductVariants(this.variant.productId).then(data => {
                            this.variants = data.variants;
                        });
                        this.variant.marketplaces.map((m) => {
                            m.availability = this.oldDispos[m.availability];
                        });
                    });
                }
            },
        },
        data() {
            return {
                imgURL: "http://163.172.150.46:3000/img",
                modal: '',
                currencies: [["dol", "USD $"], ["cad", "CAD $"], ["aud", "AUD $"], ["sgd", "SGD $"], ["hkd", "HKD $"], ["twd", "TWD $"], ["pnd", "GBP £"], ["aed", "AED د.إ"], ["rub", "RUB ₽"], ["eur", "EUR €"], ["cny", "CNY ¥"], ["yen", "JPY ¥"], ["nzd", "NZD $"], ["inr", "INR ₹"], ["php", "PHP ₱"], ["ron", "RON Lei"], [" Korea South Korean Won", "SKW 원"], ["Ukrenian Hryvnias", "UAH ₴"]],
                oldDispos: {
                    stock: "In Stock",
                    soon: "Coming Soon / Pre-Order",
                    limited: "Limited Edition",
                    unique: "Unique Piece",
                    few: "Few in Stock",
                    seeking: "Seeking New Stock",
                    rare: "Rare",
                    unfindable: "Unfindable",
                    not: "Not for sale"
                },
                variant: {
                    _id: null,
                    name: "",
                    productId: "",
                    available: true,
                    online: false,
                    mainColors: [],
                    marketplaces: [],
                    colors: [],
                    tags: [],
                    pictures: [],
                    mobilePictures: [],
                    mainPicture: "",
                    description: "",
                    comment: "",
                    collaborators: [],
                    list: ""
                },
                model: {
                    _id: "",
                    name: "",
                    brand: "",
                    description: "",
                    comment: "",
                    marketplaces: [],
                    tags: [],
                    colors: [],
                    mainColors: [],
                    list: ""
                },
                emptyMarketplace: {id: null, new: true, ucp: "", name: "", logo: "", asin: "", qte: null, website: "", price: null, isBrand: false, currency: "dol", percentSale: null, endSaleDate: null, lastModif: new Date(), availability: "In Stock"},
                marketplace: {},
                variants: [],
                hierarchyOpened: {
                    style: false,
                    category: false,
                    tag: false,
                    devices: false,
                    materials: false,
                },
                files: null,
                url: '',
            }
        },
        methods: {
            ...mapActions('product', [
                'getVariant',
                'getProduct',
                'getTags',
                'getColors',
                'createVariant',
                'updateVariant',
                'getProductVariants',
                'uploadImage',
                'uploadImageFromInternet',
                'updateProduct',
                'createTag',
                'createColor',
                'duplicateVariant',
                'createProduct',
            ]),
            ...mapActions('brand', [
                'getBrands',
                'getMarketplaces',
            ]),
            onFileChange(e) {
                this.files = e.target.files || e.dataTransfer.files;
            },
            uploadPicture() {
                if (!this.files || this.files.length <= 0) return;
                const split = this.files[0].name.split(".");
                let reader = new FileReader();
                reader.readAsDataURL(this.files[0]);
                reader.onload = () => {
                    const image = reader.result.split(',')[1];
                    this.uploadImage({image, ext: split[split.length - 1], name: null, type: ''})
                    .then(res => {
                        if (res.data.success) {
                            this.pending = "";
                            this.variant.pictures.push(res.data.file);
                            this.uploadImageError = "";
                        } else {
                            this.pending = res.data.err.message;
                            this.uploadImageError = res.data.msg;
                        }
                    });
                };
            },
            uploadPictureFromInternet(url) {
                this.uploadImageFromInternet(url)
                    .then(data => {
                        this.variant.pictures.push(data.data.file);
                    });
            },
            addMarketplace() {
                if (this.marketplace.new) {
                    this.marketplace.new = false;
                    this.variant.marketplaces.push(JSON.parse(JSON.stringify(this.marketplace)));
                } else {
                    let index = -1;
                    this.variant.marketplaces.map((e, i) => {
                        if (e.website === this.marketplace.website) index = i;
                    });
                    if (index !== -1) {
                        this.variant.marketplaces[index] = this.marketplace;
                    }
                }
                this.marketplace = JSON.parse(JSON.stringify(this.emptyMarketplace));
                this.modal = '';
            },
            saveVariant() {
                this.variant.productId = this.model._id;
                if (this.variant.productId === "") {
                    return Swal.fire({icon: 'error', title: 'Oops...', text: 'Model Id can\'t be empty!',})
                }
                var variant = JSON.parse(JSON.stringify(this.variant));
                variant.colors = variant.colors.map(x => x._id);
                variant.mainColors = variant.mainColors.map(x => x._id);
                variant.tags = variant.tags.map(x => x._id);
                variant.collaborators = variant.collaborators.map(x => x._id);
                if (variant._id === null) {
                    this.createVariant(variant).then(() => {
                        return this.$notify({
                            group: 'success',
                            title: 'Variant saved',
                            text: 'The variant has been successfully saved'
                        })
                    })
                } else {
                    this.updateVariant(variant).then(() => {
                        return this.$notify({
                            group: 'success',
                            title: 'Variant updated',
                            text: 'The variant has been successfully updated'
                        })
                    })
                }
            },
            getNewModel(id) {
                this.getProduct(id).then((data) => {
                    this.model = data.product;
                });
            },
            findOrCreateTag(item, type) {
                let tag = null;
                this.tags[type].map((e) => {
                    if (e.name.toLowerCase() === item.toLowerCase()) tag = e;
                });
                if (tag !== null) {
                    this.variant.tags.push(tag);
                } else {
                    this.createTag({name: item, type}).then((res) => {
                        this.variant.tags.push(res);
                    });
                }
            },
            findOrCreateColor(item, type) {
                const split = item.split(":");
                if (split.length < 2) {
                    return this.$notify({
                        group: 'error',
                        title: 'Can\'t create error',
                        text: 'You need to use this format --> "Color name : #colorHash" (spaces allowed)'
                    })
                }
                const name = split[0];
                const hash = split[1].trim();
                let color = null;
                this.colors.map((e) => {
                    if (e.colorName.toLowerCase() === item.toLowerCase()) color = e;
                });
                if (color !== null) {
                    if (type === 'main') {
                        this.variant.mainColors.push(color);
                    } else {
                        this.variant.colors.push(color);
                    }
                } else {
                    this.createColor({colorName: name, color: hash}).then((res) => {
                        if (type === 'main') {
                            this.variant.mainColors.push(res);
                        } else {
                            this.variant.colors.push(res);
                        }
                    });
                }
            },
            getCurrency(name) {
                let curr = ['', ''];
                this.currencies.map((e) => {
                    if (e[0] === name) {
                        curr = e[1].split(' ');
                    }
                })
                return curr;
            },
            duplicateThisVariant(id) {
                this.duplicateVariant(id).then(data => {
                    this.$router.push({ name: 'admin_products_variant', params: { id: data.data.product._id }});
                })
            },
            createAProduct() {
                if (this.model.ean !== "") {
                    this.createProduct(this.model).then(res => {
                        if (res.success) {
                            this.model = res.product;
                        }
                    });
                }
            }
        },
        computed: {
            ...mapGetters('product', [
                'tags',
                'colors',
            ]),
            ...mapGetters('brand', [
                'brands',
                'marketplaces',
            ])
        }
    }
</script>

<style scoped lang="scss">
    textarea {
        min-height: 200px;
        width: 100%;
        padding: 5px;
    }
    .VueCarousel {
        margin: 50px 0;

        .VueCarousel-wrapper {
            background-color: #5b7571;
            border-radius: 5px;
            padding: 20px;
        }
    }
    .adm-img {
        height: 200px;
    }
    .variants  {
        display: flex;
        flex-wrap: wrap;
        overflow: scroll;
        padding: 0 30px;
        margin-bottom: 30px;

        > div, > a {
            height: 120px;
            width: 80px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin: 0 10px 10px 0;
        }
        .model {
            background-color: var(--main-green);
            color: #fff;
            cursor: pointer;
        }
        .model.duplicate {
            font-size: 14px;
            align-self: center;
            height: 40px;
        }
    }
    .marketplaces {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-row-gap: 30px;
        grid-column-gap: 30px;

        .item {
            border-radius: 10px;
            box-shadow: 0 0 10px 0 rgba(0,0,0,0.16);
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            background-color: #fff;
            position: relative;

            h3 {
                cursor: pointer;
                svg {
                    color: #666;
                }
            }
            .close {
                position: absolute;
                top: 10px;
                right: 10px;
                background-color: red;
                border: 0;
                height: 15px;
                width: 15px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                font-size: 10px;
                cursor: pointer;
            }
            &.green-btn {
                background-color: var(--main-green);
                font-size: 14px;
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;

                h3 {
                    font-size: 14px;
                }
            }
            h3 {
                font-size: 18px;
            }
        }
    }
    .carousel-img {
        background-color: #bcbaba;
        padding: 20px 10px;
        border-radius: 5px;
        margin: 20px 0;
        .img-container {
            overflow-x: scroll;
            .img-item {
                display: inline-block;
            }
        }
    }
    .custom-input {
        display: flex;
        input {
            flex: 1;
            padding: 10px;
            border: 1px solid #000;
            border-radius: 5px 0 0 5px;
        }
        button {
            background-color: var(--main-green);
            color: #fff;
            border: 0;
            font-size: 20px;
            width: 50px;
            border-radius: 0 5px 5px 0;
            cursor: pointer;
            margin: 0;
        }
    }
    .img-item {
        position: relative;
        background-color: #848080;
        margin-left: 20px;
        border-radius: 3px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: stretch;
        button {
            width: 30px;
            height: 30px;
            background-color: var(--main-green);
            color: #fff;
            border-radius: 3px;
            position: absolute;
            border: 0;
            bottom: 8px;
            right: 5px;
            cursor: pointer;
            &:nth-child(2) {
                right: 40px;
            }
            &:nth-child(3) {
                right: 75px;
            }
            &.remove {
                background-color: var(--danger);
            }
        }
    }
    .m-b-30 {
        margin-bottom: 30px;
    }
    .form {
        .green-btn {
            width: initial;
            margin: 0 auto 10px;
            padding: 5px 25px;
        }
    }
    .check {
        text-align: left;
        margin-bottom: 20px;
        label:first-child {
            vertical-align: super;
        }
        input[type="checkbox"] {
            display: none;
            &:checked + .slide {
                background-color: var(--light-green);
                div {
                    margin-left: 30px;
                    background-color: #FFF;
                }
            }
        }
        .slide {
            height: 30px;
            width: 60px;
            border-radius: 15px;
            border: 2px solid var(--main-green);
            padding: 2px;
            box-sizing: border-box;
            display: inline-block;
            transition-duration: 0.3s;
            background-color: #FFF;
            div {
                height: 20px;
                width: 20px;
                border-radius: 11px;
                display: inline-block;
                cursor: pointer;
                transition-duration: 0.3s;
                background-color: #FFF;
                border: 1px solid var(--light-green);
            }
        }
    }
    .flex {
        display: flex;
        align-items: center;
        hr > {
            flex: 1;
        }
    }
</style>
<style>
    .color-square {
        height: 15px;
        width: 15px;
        display: inline-block;
        margin-right: 5px;
    }
    .autocomplete__results__item {
        text-align: left;
    }
</style>
